module.exports = __webpack_public_path__ + "img/printId.0a6347bc.jpg";